import request from '@/utils/request'

const api = {
    getUserTeamList: '/team/getUserTeamList',
    changeTeam: "/team/changeTeam",
    editUserTeamInfo:"/team/editUserTeamInfo",
    getTeamDetail: "/team/getTeamDetail",
    getTeamUser: "/team/getTeamUser",
    getTeamList:"/team/getTeamList",
    updTeamUserNum:"/team/updTeamUserNum",
    editTeamInfo: "/team/editTeamInfo",
    inviteUser: "/agentUserAddTeam",
    delTeamUser: "/team/delTeamUser"
}

export default api

export function getUserTeamList(data) {
    return request({
        url: api.getUserTeamList,
        method: 'post',
        data
    })
}
export function changeTeam(data) {
    return request({
        url: api.changeTeam,
        method: 'post',
        data
    })
}
export function editUserTeamInfo(data) {
    return request({
        url: api.editUserTeamInfo,
        method: 'post',
        data
    })
}
export function getTeamDetail(data) {
    return request({
        url: api.getTeamDetail,
        method: 'post',
        data
    })
}

export function getTeamUser(data) {
    return request({
        url: api.getTeamUser,
        method: 'post',
        data
    })
}

export function getTeamList(data) {
    return request({
        url: api.getTeamList,
        method: 'post',
        data
    })
}

export function updTeamUserNum(data) {
    return request({
        url: api.updTeamUserNum,
        method: 'post',
        data
    })
}

export function editTeamInfo(data) {
    return request({
        url: api.editTeamInfo,
        method: 'post',
        data
    })
}

export function inviteUser(data) {
    return request({
        url: api.inviteUser,
        method: 'post',
        data
    })
}

export function delTeamUser(data) {
    return request({
        url: api.delTeamUser,
        method: 'post',
        data
    })
}